import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';

interface EventTypeStatusProps {
  isActive: boolean;
  onActiveChange: (value: boolean) => void;
}

export function EventTypeStatus({
  isActive,
  onActiveChange,
}: EventTypeStatusProps) {
  return (
    <div className="flex justify-between items-center">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <h4 className="font-medium">Event Status</h4>
          <Badge variant={isActive ? 'default' : 'outline'}>
            {isActive ? 'Active' : 'Inactive'}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">
          {isActive
            ? 'Event type is available for booking'
            : 'Event type is hidden from booking pages'}
        </p>
      </div>
      <div className="flex items-center space-x-2">
        <Switch
          id="event-active"
          checked={isActive}
          onCheckedChange={onActiveChange}
        />
        <Label htmlFor="event-active">{isActive ? 'Active' : 'Inactive'}</Label>
      </div>
    </div>
  );
}
